// @flow
import Notifications from '../constants/Notifications';
import BaseBody from './abstract/BaseBody';

export default class Body extends BaseBody {
  /**
   * Initialize the component.
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.addListener(Notifications.TOGGLE_FILTER, this.toggleFilters);
    this.addListener(Notifications.FOCUSED_ON_SEARCH, () => this.setSearchState(true));
    this.addListener(Notifications.HIDE_SEARCH_SUGGESTIONS, () => this.setSearchState(false));
    this.scrollToId();
  }

  /**
   * Fake the height of the page,
   * Example: needed on search suggestions for mobile.
   * Reduces the scroll impact of the keyboard on input focus.
   *
   * @param searching
   */
  setSearchState(searching: boolean): void {
    if (!searching) {
      this.el.classList.remove('searching');
    } else {
      this.el.classList.add('searching');
    }
  }

  /**
   * Toggle the filters on the category page.
   */
  toggleFilters(): void {
    this.toggleScrollBlocker();
  }

  /**
   *
   */
  scrollToId() {
    if (!window.location.hash) return;
    const element = document.querySelector(window.location.hash);
    if (!element) return;
    window.scrollTo(0, element.getBoundingClientRect().top);
  }
}
